import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { isNil } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import withRouter from '../../../lib/withRouter'
import actions from '../../../actions/Censuses'
import { createImport, resetImport } from '../../../actions/CensusImports'
import alert from '../../../alert'
import CensusesSelectFieldComponent from '../common/CensusesSelectFieldComponent'
import CensusForm from './CensusForm'

export class CensusCreate extends Component {
  static propTypes = {
    create: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    index: PropTypes.func.isRequired,
    indexReset: PropTypes.func.isRequired,
    requestInProgress: PropTypes.bool,
    generalError: PropTypes.string,
    resourceErrors: PropTypes.object,
    created: PropTypes.bool.isRequired,
    records: PropTypes.array,
    id: PropTypes.number,
    history: PropTypes.func.isRequired
  }

  componentDidMount() {
    this.props.index()
  }

  componentWillUnmount() {
    this.props.indexReset()
    this.props.reset()
  }

  handleSubmit = (values) => {
    this.props.create(values)
  }

  handleCensusChange = (name, value) => {
    if (value === 'NewCensus') { return }

    this.props.history(`/censuses/${value}/edit`)
  }

  render() {
    const {
      generalError,
      resourceErrors,
      created,
      id
    } = this.props

    const requestInProgress = this.props.requestInProgress === true

    if (!isNil(generalError)) {
      alert(generalError)
    }

    if (created && !isNil(this.props.id)) {
      return this.props.history(`/censuses/${id}/edit`)
    }

    const errors = isNil(resourceErrors) ? {} : resourceErrors

    return (
      <div className="content">
        <CensusesSelectFieldComponent
          value="NewCensus"
          handleChange={this.handleCensusChange}
          displayNewCensus
          censuses={this.props.records}
        />

        <CensusForm
          onSubmit={this.handleSubmit}
          errors={errors}
          initialValues={{ name: '', families_attributes: [] }}
          submitLabel="Create Census"
          requestInProgress={requestInProgress}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const slice = state.censuses.create
  const indexSlice = state.censuses.index

  return {
    generalError: slice.generalError,
    resourceErrors: slice.resourceErrors,
    requestInProgress: slice.requestInProgress,
    id: slice.id,
    created: slice.created,
    records: indexSlice.records
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  create: actions.create.main,
  reset: actions.create.reset,
  index: actions.index.main,
  indexReset: actions.index.reset,
  createImport,
  createImportReset: resetImport
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CensusCreate))
